import { useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";

export const TasksBlock = ({ tasks, leadId, reload }) => {
  const [title, setTitle] = useState("");
  const [due, setDue] = useState("");
  const [saving, setSaving] = useState(false);

  const add = async () => {
    setSaving(true);
    try {
      await api.post(`/leads/${leadId}/tasks`, { title, due_date: due || null });
      setTitle(""); setDue("");
      toast.success("Tarea creada");
      reload();
    } catch (e) { toast.error(errorMessage(e)); } finally { setSaving(false); }
  };

  const toggle = async (t) => {
    try { await api.patch(`/leads/${leadId}/tasks/${t.id}`, { completed: !t.completed }); reload(); } catch (e) { toast.error(errorMessage(e)); }
  };

  return (
    <div data-testid="tasks-block">
      <h3 className="text-sm font-bold">Tareas</h3>
      <div className="mt-3 space-y-2">
        <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Nueva tarea" className="h-10 rounded-xl" data-testid="task-title-input" />
        <div className="flex gap-2">
          <Input type="date" value={due} onChange={(e) => setDue(e.target.value)} className="h-10 flex-1 rounded-xl" data-testid="task-due-input" />
          <Button onClick={add} disabled={!title.trim() || saving} className="h-10 rounded-xl bg-[#0B2545]" data-testid="add-task-button"><Plus className="h-4 w-4" /></Button>
        </div>
      </div>
      <ul className="mt-4 space-y-2" data-testid="tasks-list">
        {tasks.length === 0 && <li className="text-sm text-slate-400">Sin tareas</li>}
        {tasks.map((t) => (
          <li key={t.id} className="flex items-start gap-3 rounded-xl border border-slate-100 p-3" data-testid={`task-item-${t.id}`}>
            <Checkbox checked={t.completed} onCheckedChange={() => toggle(t)} className="mt-0.5" data-testid={`task-toggle-${t.id}`} />
            <div className="min-w-0 flex-1">
              <p className={`text-sm font-medium ${t.completed ? "text-slate-400 line-through" : ""}`}>{t.title}</p>
              <p className="text-xs text-slate-400">
                {t.due_date ? `Vence ${fmtDate(t.due_date)}` : "Sin fecha"}
                {t.completed && <span className="ml-1 text-emerald-600" data-testid={`task-completed-label-${t.id}`}>· Completada</span>}
              </p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
